import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
import Swiper from 'swiper'
import {Autoplay,EffectFade,Navigation,Thumbs} from 'swiper/modules';

gsap.registerPlugin(ScrollTrigger)
  ; (function($) {
    'use strict'

    var Product = {
      init: function() {
        if($('.section-product-detail-summary').length > 0) {
          this.productDetail()
        }

        if($('.filter-navigation').length > 0) {
          this.handleOpenFilter()
        }
      },

      // Product Detail Setup
      productDetail: function() {
        const $section = $('.section-product-detail-summary')
        const $galleryTop = $section.find('.gallery-top')[0]
        const $galleryThumbs = $section.find('.gallery-thumbs')[0]
        const $productNavigation = $('.fixed-product-navigation')

        var galleryThumbs = new Swiper($galleryThumbs,{
          speed: 600,
          loop: false,
          spaceBetween: '0',
          slideToClickedSlide: true,
          slidesPerView: "auto",
          centeredSlides: false,
          allowTouchMove: true,
          grabCursor: true,
          updateOnWindowResize: true,
        })

        var galleryTop = new Swiper($galleryTop,{
          modules: [Autoplay,Thumbs,EffectFade,Navigation],
          effect: 'fade',
          fadeEffect: {crossFade: true},
          speed: 600,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          spaceBetween: '0',
          slidesPerView: 1,
          loop: false,
          allowTouchMove: false,
          grabCursor: false,
          thumbs: {
            swiper: galleryThumbs
          },
          navigation: {
            nextEl: '.product-button-next',
            prevEl: '.product-button-prev',
          },
        })


        $(window).on('scroll',function() {
          const headerHeight = $('.page-header').outerHeight();
          const stickyPosition = $('.page-header').hasClass('hide') ? 0 : headerHeight;

          if($(window).scrollTop() > $section.outerHeight()) {
            $productNavigation.addClass('active');
            $productNavigation.css('top',stickyPosition + 'px');
          } else {
            $productNavigation.removeClass('active');
          }
        });

        return () => {
          galleryTop.destroy(true,true) // Add cleanup
          galleryThumbs.destroy(true,true) // Add cleanup
        }
      },

      // Handle Open Filter
      handleOpenFilter: function() {
        const $sectionProductList = $(".product-list-wrapper")
        const $filterNavigation = $('.filter-navigation')
        const $formFilter = $('.form-filter');
        const $dropdown = $formFilter.find('.form-filter-dropdown');
        let isAnimating = false;

        function closeFilter() {
          if(isAnimating) return;

          isAnimating = true;
          $formFilter.removeClass('active');
          $('.form-filter-dropdown').slideUp(300,function() {
            isAnimating = false;
          });
        }

        // Open Filter
        $('.form-filter-input').on("click",function(e) {
          e.stopPropagation();
          if(isAnimating) return;

          if(!$formFilter.hasClass('active')) {
            isAnimating = true;
            $formFilter.addClass('active');
            $dropdown.slideDown(300,function() {
              isAnimating = false;
            });
          } else {
            isAnimating = true;
            $formFilter.removeClass('active');
            $dropdown.slideUp(300,function() {
              isAnimating = false;
            });
          }
        });

        // Close Filter
        $('#close-filter').on("click",function() {
          closeFilter()
        })

        const $header = $('.page-header');
        const sentinel = $('<div></div>').css({
          height: '1px',
          margin: 0,
          padding: 0
        });

        // Chèn sentinel ngay trước filter-navigation
        $filterNavigation.before(sentinel);

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if(entry.isIntersecting) {
              $filterNavigation.removeClass('is-sticky');
            } else {
              $filterNavigation.addClass('is-sticky');
            }
          });
        },{
          threshold: 0
        });

        observer.observe(sentinel[0]);

        // Cập nhật vị trí top mỗi lần scroll (nếu cần)
        $(window).on('scroll',function() {
          const headerHeight = $header.outerHeight();

          if($header.hasClass('hide')) {
            $filterNavigation.css('top','0');
          } else {
            $filterNavigation.css('top',headerHeight + 'px');
          }
        });


        $(document).on('click',function(e) {
          if(!$(e.target).closest('.form-filter').length) {
            closeFilter()
          }
        });
      }
    }

    // Khởi chạy khi DOM ready
    $(function() {
      Product.init()
    })
  })(jQuery)
